export const ERROR_STATUS = Object.freeze({
  notFound: 404,
})
